__turbopack_context__.v({
  "gear_icon": "StationMenu-module-scss-module__SHVFDa__gear_icon",
  "is_open": "StationMenu-module-scss-module__SHVFDa__is_open",
  "my_station_icon": "StationMenu-module-scss-module__SHVFDa__my_station_icon",
  "next_icon": "StationMenu-module-scss-module__SHVFDa__next_icon",
  "station_button": "StationMenu-module-scss-module__SHVFDa__station_button",
  "station_menu": "StationMenu-module-scss-module__SHVFDa__station_menu",
  "station_menu_change_station_button": "StationMenu-module-scss-module__SHVFDa__station_menu_change_station_button",
  "station_menu_description": "StationMenu-module-scss-module__SHVFDa__station_menu_description",
  "station_menu_explore_more_link": "StationMenu-module-scss-module__SHVFDa__station_menu_explore_more_link",
  "station_menu_info": "StationMenu-module-scss-module__SHVFDa__station_menu_info",
  "station_menu_info_title": "StationMenu-module-scss-module__SHVFDa__station_menu_info_title",
  "station_menu_inner": "StationMenu-module-scss-module__SHVFDa__station_menu_inner",
  "station_menu_item": "StationMenu-module-scss-module__SHVFDa__station_menu_item",
  "station_menu_link": "StationMenu-module-scss-module__SHVFDa__station_menu_link",
  "station_menu_links": "StationMenu-module-scss-module__SHVFDa__station_menu_links",
  "station_menu_logo": "StationMenu-module-scss-module__SHVFDa__station_menu_logo",
  "station_menu_more_from_station": "StationMenu-module-scss-module__SHVFDa__station_menu_more_from_station",
});
